module.exports = __webpack_public_path__ + "img/sub-cat-motivation.8d2a3a2d.svg";